import PropTypes from "prop-types";
import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { getDiscountPrice } from "../../helpers/product";
import Rating from "./sub-components/ProductRating";
import ProductModal from "./ProductModal";

const ProductGridListSingle = (props) => {
  const {
    product,
    currency,
    addToCart,
    addToWishlist,
    removeFromWishlist,
    addToCompare,
    cartItem,
    wishlistItem,
    compareItem,
    sliderClassName,
    spaceBottomClass,
    isLoggedUser,
    visualizzaPrezzi,
    cartItems,
    userData,
    oneProduct,
  } = props;

  const [modalShow, setModalShow] = useState(false);
  const { addToast } = useToasts();

  const discountedPrice = getDiscountPrice(
    product.price,
    product.discount,
    product.pricesco
  );
  const finalProductPrice = product.price
    ? (+(product.price * currency.currencyRate)).toFixed(2)
    : 0;
  const finalDiscountedPrice = +(
    product.pricesco * currency.currencyRate
  ).toFixed(2);
  var strings = require("../../translations/italian.json");

  function imageExists(image_url) {
    var xhr = new XMLHttpRequest();
    xhr.open("HEAD", image_url, false);
    xhr.send();

    if (xhr.status == "404") {
      console.log("File doesn't exist");
      return false;
    } else {
      console.log("File exists");
      return true;
    }
  }

  const toggleWishlist = () => {
    if (wishlistItem !== undefined) removeFromWishlist(product, addToast);
    else addToWishlist(product, addToast);
  };

  return (
    <Fragment>
      <div
        className={`${oneProduct ? "" : "col-xl-2 col-sm-7"} ${
          sliderClassName ? sliderClassName : ""
        } pb-20`}
        style={{ position: "relative" }}
      >
        {/*<div>
          <div className="col-xl-8 col-lg-8 d-none d-lg-block">
            visualizzaione Desktop
          </div>
          <div className="d-block d-lg-none">
            visualizzazione Mobile
          </div>
        </div>*/}
        <div
          className={`product-wrap ${spaceBottomClass ? spaceBottomClass : ""}`}
        >
          <div className="product-img">
            <Link to={process.env.PUBLIC_URL + "/product/" + product.id}>
              <img
                className="default-img"
                id={"image-prod-" + product.id}
                //src={(imageExists(global.baseUrlImage + product.image[0]) && product.image[0] != "") ? global.baseUrlImage + product.image[0] : "https://dgaplanetshirt.com/assets/img/logo/logo.png"}

                src={
                  product.image[0] || product.image.length > 0
                    ? global.baseUrlImage + product.image[0]
                    : global.placeholderImage
                }
                onError={() => {
                  var elms = document.querySelectorAll(
                    "[id='" + "image-prod-" + product.id + "']"
                  );
                  for (var i = 0; i < elms.length; i++) {
                    elms[i].src = global.placeholderImage;
                    elms[i].style.objectFit = "contain";
                  }
                }}
                style={{ height: "30vh", objectFit: "contain" }}
                alt=""
              />
              {product.image.length > 1 ? (
                <img
                  className="hover-img"
                  src={global.baseUrlImage + product.image[1]}
                  alt=""
                />
              ) : (
                ""
              )}
            </Link>

            {/*<div className="d-block d-lg-none">
              <button onClick={() => setModalShow(true)} style={{ width: '100%', borderColor: "transparent", backgroundColor: 'transparent' }} title="Quick View2">
                <img
                  className="default-img"
                  id={"image-prod-" + product.id}
                  //src={(imageExists(global.baseUrlImage + product.image[0]) && product.image[0] != "") ? global.baseUrlImage + product.image[0] : "https://dgaplanetshirt.com/assets/img/logo/logo.png"}

                  src={global.baseUrlImage + product.image[0]}
                  onError={() => {
                    document.getElementById("image-prod-" + product.id).src = 'https://dgaplanetshirt.com/assets/img/logo/logo.png'
                    document.getElementById("image-prod-" + product.id).style.objectFit = "contain"
                  }
                  }
                  style={{ height: "30vh", objectFit: "contain" }}
                  alt=""
                />
                {product.image.length > 1 ? (
                  <img
                    className="hover-img"
                    src={global.baseUrlImage + product.image[1]}
                    alt=""
                  />
                ) : (
                  ""
                )}
              </button>
              </div>*/}

            {/*product.discount || product.new ? (
              <div className="product-img-badges">
                {product.discount ? (
                  <span className="pink">-{product.discount}%</span>
                ) : (
                  ""
                )}
                {product.new ? <span className="purple">New</span> : ""}
              </div>
            ) : (
              ""
            )*/}
            {product.altdat3 === "1" && userData.user.user?.showPromo ? (
              <div className="product-img-badges">
                <span className="pink">PROMO</span>
              </div>
            ) : (
              ""
            )}
            <div className="product-action">
              <div className="pro-same-action pro-wishlist">
                <button
                  className={wishlistItem !== undefined ? "active" : ""}
                  //disabled={8wishlistItem !== undefined}
                  title={
                    wishlistItem !== undefined
                      ? "Aggiunto ai preferiti"
                      : "Aggiungi ai preferiti"
                  }
                  onClick={() => toggleWishlist()}
                >
                  <i className="pe-7s-like" />
                </button>
              </div>
              <div
                className="pro-same-action pro-cart"
                style={{ fontSize: "20px" }}
              >
                {product.affiliateLink ? (
                  <a
                    href={product.affiliateLink}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    {" "}
                    Buy now{" "}
                  </a>
                ) : product.variation && product.variation.length >= 1 ? (
                  <Link
                    to={`${process.env.PUBLIC_URL}/product/${product.id}`}
                    style={{ fontSize: "15px" }}
                  >
                    Visualizza
                  </Link>
                ) : (product.stock && product.stock > 0) ||
                  global.aziendaID == 2 ? (
                  <button
                    onClick={() => addToCart(product, addToast)}
                    style={{
                      fontSize: cartItem?.quantity > 0 ? "12px" : "10px",
                    }}
                    className={
                      cartItem !== undefined && cartItem.quantity > 0
                        ? "active"
                        : ""
                    }
                    disabled={cartItem !== undefined && cartItem.quantity > 0}
                    title={
                      cartItem !== undefined
                        ? strings.added_to_cart
                        : strings.add_to_cart
                    }
                  >
                    {" "}
                    <i className="pe-7s-cart"></i>{" "}
                    {cartItem !== undefined && cartItem.quantity > 0
                      ? "Aggiunto"
                      : strings.add_to_cart}
                  </button>
                ) : (
                  <button disabled className="active">
                    Non disponibile
                  </button>
                )}
              </div>
              <div className="pro-same-action pro-quickview">
                <button onClick={() => setModalShow(true)} title="Quick View">
                  <i className="pe-7s-look" />
                </button>
              </div>
            </div>

            {product.altdat1 && global.aziendaID == 1 && (
              <div
                className={`product-content text-center pb-10`}
                style={{
                  display: "none",
                  position: "absolute",
                  top: -30,
                  right: 10,
                  height: "50px",
                  backgroundColor: "white",
                  padding: "2px",
                  alignContent: "end",
                }}
              >
                <img src={product.altdat1} height="20px" />
              </div>
            )}
          </div>
          <div className="product-content text-center">
            {global.aziendaID == 1 && (
              <img src={product.altdat1} height="20px" />
            )}

            <h3>
              <Link
                to={process.env.PUBLIC_URL + "/product/" + product.id}
                style={{ fontSize: "13px" }}
              >
                {"(" + product.sku + ") " + product.name}
              </Link>
            </h3>
            {product.rating && product.rating > 0 ? (
              <div className="product-rating" style={{ display: "none" }}>
                <Rating ratingValue={product.rating} />
              </div>
            ) : (
              ""
            )}
            <div className="product-price content-end">
              {global.aziendaID == 2 && isLoggedUser ? (
                <Fragment>
                  <span>
                    {currency.currencySymbol + product.pricesco.toFixed(2)}
                  </span>{" "}
                </Fragment>
              ) : null}
            </div>
          </div>
        </div>
        <div className="shop-list-wrap mb-30">
          <div className="row">
            <div className="col-xl-4 col-md-5 col-sm-6">
              <div className="product-list-image-wrap">
                <div className="product-img">
                  <Link to={process.env.PUBLIC_URL + "/product/" + product.id}>
                    <img
                      className="default-img img-fluid"
                      id={"image-prod-" + product.id}
                      src={global.baseUrlImage + product.image[0]}
                      alt=""
                      onError={() => {
                        var elms = document.querySelectorAll(
                          "[id='" + "image-prod-" + product.id + "']"
                        );
                        for (var i = 0; i < elms.length; i++) {
                          elms[i].src = global.placeholderImage;
                          elms[i].style.objectFit = "contain";
                        }
                      }}
                    />
                    {product.image.length > 1 ? (
                      <img
                        className="hover-img img-fluid"
                        src={global.baseUrlImage + product.image[1]}
                        alt=""
                        onError={() => {
                          document.getElementById(
                            "image-prod-" + product.id
                          ).src = global.placeholderImage;
                          document.getElementById(
                            "image-prod-" + product.id
                          ).style.objectFit = "cover";
                        }}
                      />
                    ) : (
                      ""
                    )}
                  </Link>
                  {/*product.discount || product.new ? (
                    <div className="product-img-badges">
                      {product.discount ? (
                        <span className="pink">-{product.discount}%</span>
                      ) : (
                        ""
                      )}
                      {product.new ? <span className="purple">New</span> : ""}
                    </div>
                  ) : (
                    ""
                  )*/}
                </div>
              </div>
            </div>
            <div className="col-xl-8 col-md-7 col-sm-6">
              <div className="shop-list-content">
                <h3>
                  <Link to={process.env.PUBLIC_URL + "/product/" + product.id}>
                    {product.name}
                  </Link>
                </h3>
                <div className="product-list-price">
                  {discountedPrice !== null ? (
                    <Fragment>
                      <span>
                        {currency.currencySymbol + finalDiscountedPrice}
                      </span>{" "}
                      {/*<span className="old">
                        {currency.currencySymbol + finalProductPrice}
                  </span>*/}
                    </Fragment>
                  ) : (
                    <span>{currency.currencySymbol + finalProductPrice} </span>
                  )}
                </div>
                {product.rating && product.rating > 0 ? (
                  <div className="rating-review">
                    <div className="product-list-rating">
                      <Rating ratingValue={product.rating} />
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {product.shortDescription ? (
                  <p>{product.shortDescription}</p>
                ) : (
                  ""
                )}

                <div className="shop-list-actions d-flex align-items-center">
                  <div
                    className="shop-list-btn btn-hover"
                    style={{ fontSize: "20px" }}
                  >
                    {product.affiliateLink ? (
                      <a
                        href={product.affiliateLink}
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        {" "}
                        Buy now{" "}
                      </a>
                    ) : product.variation && product.variation.length >= 1 ? (
                      <Link
                        to={`${process.env.PUBLIC_URL}/product/${product.id}`}
                      >
                        Seleziona opzioni
                      </Link>
                    ) : (product.stock && product.stock > 0) ||
                      global.aziendaID == 2 ? (
                      <button
                        onClick={() => addToCart(product, addToast)}
                        style={{
                          fontSize: cartItem?.quantity > 0 ? "12px" : "10px",
                        }}
                        className={
                          cartItem !== undefined && cartItem.quantity > 0
                            ? "active"
                            : ""
                        }
                        disabled={
                          cartItem !== undefined && cartItem.quantity > 0
                        }
                        title={
                          cartItem !== undefined
                            ? strings.added_to_cart
                            : strings.add_to_cart
                        }
                      >
                        {" "}
                        <i className="pe-7s-cart"></i>{" "}
                        {cartItem !== undefined && cartItem.quantity > 0
                          ? "Aggiunto"
                          : strings.add_to_cart}
                      </button>
                    ) : (
                      <button disabled className="active">
                        Non disponibile
                      </button>
                    )}
                  </div>

                  <div className="shop-list-wishlist ml-10">
                    <button
                      className={wishlistItem !== undefined ? "active" : ""}
                      disabled={wishlistItem !== undefined}
                      title={
                        wishlistItem !== undefined
                          ? "Aggiunto ai preferiti"
                          : "Aggiungi ai preferiti"
                      }
                      //onClick={() => addToWishlist(product, addToast)}
                    >
                      <i className="pe-7s-like" />
                    </button>
                  </div>
                  <div className="shop-list-compare ml-10">
                    <button
                      className={compareItem !== undefined ? "active" : ""}
                      disabled={compareItem !== undefined}
                      title={
                        compareItem !== undefined
                          ? "Added to compare"
                          : "Add to compare"
                      }
                      onClick={() => addToCompare(product, addToast)}
                    >
                      <i className="pe-7s-shuffle" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* product modal */}
      {modalShow && (
        <ProductModal
          isLoggedUser={isLoggedUser}
          visualizzaPrezzi={visualizzaPrezzi}
          show={modalShow}
          onHide={() => setModalShow(false)}
          product={product}
          currency={currency}
          discountedprice={discountedPrice}
          finalproductprice={finalProductPrice}
          finaldiscountedprice={finalDiscountedPrice}
          cartitem={cartItem}
          cartItems={cartItems}
          wishlistitem={wishlistItem}
          compareitem={compareItem}
          addtocart={addToCart}
          addtowishlist={addToWishlist}
          addtocompare={addToCompare}
          addtoast={addToast}
        />
      )}
    </Fragment>
  );
};

ProductGridListSingle.propTypes = {
  addToCart: PropTypes.func,
  addToCompare: PropTypes.func,
  addToWishlist: PropTypes.func,
  removeFromWishlist: PropTypes.func,
  cartItem: PropTypes.object,
  compareItem: PropTypes.object,
  currency: PropTypes.object,
  product: PropTypes.object,
  sliderClassName: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  wishlistItem: PropTypes.object,
};

export default ProductGridListSingle;
